module.exports = __webpack_public_path__ + "static/media/loader1.0893fe2f.svg";